import { debugManager } from '@tunein/web-utils';
export function toggleDebug(debugMode) {
    if (debugMode && !debug.isActive) {
        debug.toggle({ verbose: debugMode === 'verbose' });
    }
}
export const debug = debugManager.createDebugger('PM', 'Player Manager');
